import basePath from "base_path";
import ActionTypes from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";

export default function ragReportOrderReset(requestor) {
  return createReduxPromiseAction(
    ActionTypes.DOCUMENT_WEBHOOKS_RESEND,
    (organisationId, projectId, documentId) =>
      requestor
        .post(
          `${basePath}/organisation/${organisationId}/project/${projectId}/document/${documentId}/webhook/resend`,
          {},
          {withCredentials: true},
        )
        .then(response => response.data),
  );
}
